// extracted by mini-css-extract-plugin
export default {"content":"PreLoad__content__qrHoN","iconGif":"PreLoad__iconGif__dSoA1","title":"PreLoad__title__mjVxo","message":"PreLoad__message__u7gsy"};